import React from 'react';
import cls from '@utils/css-select';
import { I18nMessage } from '@fe/i18n';

import styles from './styles.scss';
import Section from 'components/section';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { TEACHER_COUNTRY_CONIFG } from './const';
const cx = cls(styles);

const Message = I18nMessage('landing');
/**
 * 师资团队
 * @returns
 */
export default function TechBlock() {
	const local = useSelector((state: ConnectState) => state.app.local);
	const teachers = TEACHER_COUNTRY_CONIFG[local] || TEACHER_COUNTRY_CONIFG['en-US'];
	return (
		<div className={cx('tech-team')}>
			<Section>
				<h3 className={cx('block-title')}>
					Best tutors in the <Message id="country_name" />!
				</h3>
				<div className={cx('team-data')}>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i1')} />
						<div className={cx('nums')}>
							<strong>10,000+ </strong>
							<span>tutors</span>
						</div>
					</div>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i2')} />
						<div className={cx('nums')}>
							<strong>
								<Message id="universities" />
							</strong>
							<span>universities</span>
						</div>
					</div>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i3')} />
						<div className={cx('nums')}>
							<strong>7.8%</strong>
							<span>tutor pass rate</span>
						</div>
					</div>
				</div>
				<div className={cx('teacher-infos', 'scroll-view')}>
					{teachers.map((v) => {
						return (
							<div className={cx('item')} key={v.name}>
								<i className={cx('avatar')} style={{ backgroundImage: `url(${v.avatr})` }} />
								<div className={cx('name')}>{v.name}</div>
								<div className={cx('school')}>{v.school}</div>
								<div className={cx('score')}>
									<img loading="lazy" src="https://web-data.zmlearn.com/image/imnZ81spWbvU1No2G8C3RQ/4%402x.png" />
								</div>
								<div className={cx('desc')} dangerouslySetInnerHTML={{ __html: v.desc }} />
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
